module.exports = __webpack_public_path__ + "img/noData.9a17b5de.png";